// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3lYrP","inner":"Footer_inner__3RIe8","nextIcon":"Footer_nextIcon__w0Dkp","innerLeft":"Footer_innerLeft__2SrVA"};